import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = 'INR') {
    if (value === null || value === undefined) return '—';
    
    const formatters = {
        INR: new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 }),
        USD: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }),
        EUR: new Intl.NumberFormat('en-EU', { style: 'currency', currency: 'EUR' }),
    };
    
    return formatters[currency]?.format(value) || `${currency} ${value}`;
}

export function formatNumber(value, decimals = 2) {
    if (value === null || value === undefined) return '—';
    return Number(value).toLocaleString('en-IN', { 
        minimumFractionDigits: 0, 
        maximumFractionDigits: decimals 
    });
}

export function formatDate(dateString) {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}

export function formatDateTime(dateString) {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

export function formatRelativeTime(dateString) {
    if (!dateString) return '—';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return formatDate(dateString);
}

export function getStatusColor(status) {
    const colors = {
        active: 'status-active',
        inactive: 'status-inactive',
        under_development: 'status-development',
    };
    return colors[status] || 'status-inactive';
}

export function getStatusLabel(status) {
    const labels = {
        active: 'Active',
        inactive: 'Inactive',
        under_development: 'In Development',
    };
    return labels[status] || status;
}

export function getStockStatusColor(status) {
    const normalized = status?.toLowerCase().replace(/\s+/g, '_');
    const colors = {
        in_stock: 'text-emerald-600 bg-emerald-50 dark:text-emerald-400 dark:bg-emerald-900/30',
        low_stock: 'text-amber-600 bg-amber-50 dark:text-amber-400 dark:bg-amber-900/30',
        out_of_stock: 'text-red-600 bg-red-50 dark:text-red-400 dark:bg-red-900/30',
        made_to_order: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30',
        development: 'text-slate-600 bg-slate-100 dark:text-slate-400 dark:bg-slate-800',
    };
    return colors[normalized] || 'text-slate-600 bg-slate-100';
}

export function truncate(str, length = 50) {
    if (!str) return '';
    return str.length > length ? str.substring(0, length) + '...' : str;
}

export function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
